import { activateDocument, closeDocument } from '../state/actions';
import { useAppStore } from '../state/store';

export function TabBar() {
  const documents = useAppStore((state) => state.documents);
  const activeDocumentId = useAppStore((state) => state.activeDocumentId);

  if (documents.length === 0) return null;

  return (
    <div className="tabs">
      {documents.map((doc) => (
        <div
          key={doc.id}
          className={`tab${doc.id === activeDocumentId ? ' tab--active' : ''}`}
          onPointerDown={() => activateDocument(doc.id)}
        >
          <span className="tab__name">
            {doc.name}
            {doc.dirty ? ' •' : ''}
          </span>
          <button
            type="button"
            className="tab__close"
            title="Close document"
            onPointerDown={(event) => {
              event.stopPropagation();
              closeDocument(doc.id);
            }}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
